import React from "react";

export const copyImage = async (
  imageRef: React.RefObject<HTMLImageElement | null>
) => {
  try {
    if (imageRef.current) {
      const response = await fetch(imageRef.current.src);
      const imageBlob = await response.blob();
      const mimeType = imageBlob.type || "image/png";

      await navigator.clipboard.write([
        new ClipboardItem({
          [mimeType]: imageBlob,
        }),
      ]);
      return true;
    }
    return false;
  } catch (e) {
    console.log("error while copying the image");
    return false;
  }
};

export const downloadImage = async (
  imageRef: React.RefObject<HTMLImageElement | null>,
  downloadRef: React.RefObject<HTMLAnchorElement | null>,
  fileName: string
) => {
  try {
    if (downloadRef.current && imageRef.current) {
      const response = await fetch(imageRef.current.src);
      const imageBlob = await response.blob();
      const imageURL = URL.createObjectURL(imageBlob);

      downloadRef.current.href = imageURL;
      downloadRef.current.download = `${fileName}`;
      downloadRef.current.click();
      setTimeout(() => URL.revokeObjectURL(imageURL), 200);
    }
  } catch (e) {
    console.log("error while downloading the image");
  }
};
